import {SvgIcon} from "@mui/material";
import * as React from "react";

const LocationIcon = (props: any) => (
  <SvgIcon {...props} style={{ fontSize: "1em" }}>
    <path
      d="M8.6919 0C3.89916 0 0 3.89916 0 8.69185C0 14.6397 7.7784 23.3716 8.10957 23.7404C8.42064 24.0868 8.96373 24.0862 9.27423 23.7404C9.6054 23.3716 17.3838 14.6397 17.3838 8.69185C17.3837 3.89916 13.4846 0 8.6919 0ZM8.6919 13.065C6.28055 13.065 4.31883 11.1032 4.31883 8.69185C4.31883 6.28051 6.2806 4.31879 8.6919 4.31879C11.1032 4.31879 13.0649 6.28055 13.0649 8.6919C13.0649 11.1032 11.1032 13.065 8.6919 13.065Z"
      fill="#DE4A22"
    />
  </SvgIcon>
);
export default LocationIcon;
